import { apiClient } from '../apiClient';
import {
  acceptEulaDocument,
  acceptEulaMutation,
  acceptEulaMutationVariables,
  createEmergencyScenarioDocument,
  CreateEmergencyScenarioInput,
  createEmergencyScenarioMutation,
  createEmergencyScenarioMutationVariables,
  deleteEmergencyScenarioAccessPointsDocument,
  deleteEmergencyScenarioAccessPointsMutation,
  deleteEmergencyScenarioAccessPointsMutationVariables,
  findOrCreateUserDocument,
  findOrCreateUserMutation,
  findOrCreateUserMutationVariables,
  grantGlobalUserRoleDocument,
  grantGlobalUserRoleMutation,
  grantGlobalUserRoleMutationVariables,
  grantScopedUserRolesDocument,
  grantScopedUserRolesMutation,
  grantScopedUserRolesMutationVariables,
  sendInvitationDocument,
  sendInvitationMutation,
  sendInvitationMutationVariables,
  updateEmergencyScenarioDocument,
  UpdateEmergencyScenarioInput,
  updateEmergencyScenarioMutation,
  updateEmergencyScenarioMutationVariables,
  UpsertEmergencyScenarioAccessPointInput,
  upsertEmergencyScenarioAccessPointsDocument,
  upsertEmergencyScenarioAccessPointsMutation,
  upsertEmergencyScenarioAccessPointsMutationVariables,
} from '../generated';

// Create strongly typed functions for operations that cannot be called as hooks

export async function acceptEula() {
  const { data } = await apiClient.mutate<acceptEulaMutation, acceptEulaMutationVariables>({
    mutation: acceptEulaDocument
  });

  return data?.user;
}

export async function deleteEmergencyScenarioAccessPoints(emergencyScenarioId: string, accessPointIds: string[]) {
  await apiClient.mutate<
    deleteEmergencyScenarioAccessPointsMutation,
    deleteEmergencyScenarioAccessPointsMutationVariables
  >({
    variables: { emergencyScenarioId, accessPointIds },
    mutation: deleteEmergencyScenarioAccessPointsDocument,
  });
}

export async function findOrCreateUser(variables: findOrCreateUserMutationVariables) {
  const { data } = await apiClient.mutate<
    findOrCreateUserMutation,
    findOrCreateUserMutationVariables
  >({
    variables,
    mutation: findOrCreateUserDocument,
  });

  return data?.user;
}

export async function grantGlobalUserRole(variables: grantGlobalUserRoleMutationVariables) {
  const { data } = await apiClient.mutate<
    grantGlobalUserRoleMutation,
    grantGlobalUserRoleMutationVariables
  >({
    variables,
    mutation: grantGlobalUserRoleDocument,
  });

  return data?.grantGlobalUserRole;
}

export async function grantScopedUserRoles(variables: grantScopedUserRolesMutationVariables) {
  const { data } = await apiClient.mutate<
    grantScopedUserRolesMutation,
    grantScopedUserRolesMutationVariables
  >({
    variables,
    mutation: grantScopedUserRolesDocument,
  });

  return data?.grantScopedUserRoles || [];
}

export async function sendInvitation(variables: sendInvitationMutationVariables) {
  const { data } = await apiClient.mutate<sendInvitationMutation, sendInvitationMutationVariables>({
    variables,
    mutation: sendInvitationDocument,
  });

  return data?.sendInvitation;
}

export async function createEmergencyScenario(input: CreateEmergencyScenarioInput) {
  const { data } = await apiClient.mutate<
    createEmergencyScenarioMutation,
    createEmergencyScenarioMutationVariables
  >({
    variables: { input },
    mutation: createEmergencyScenarioDocument,
  });

  return data?.emergencyScenario;
}

export async function updateEmergencyScenario(emergencyScenarioId: string, input: UpdateEmergencyScenarioInput) {
  await apiClient.mutate<updateEmergencyScenarioMutation, updateEmergencyScenarioMutationVariables>({
    mutation: updateEmergencyScenarioDocument,
    variables: { emergencyScenarioId, input },
  });
}

export async function upsertEmergencyScenarioAccessPoints(
  emergencyScenarioId: string,
  inputs: UpsertEmergencyScenarioAccessPointInput[],
) {
  await apiClient.mutate<
    upsertEmergencyScenarioAccessPointsMutation,
    upsertEmergencyScenarioAccessPointsMutationVariables
  >({
    variables: { emergencyScenarioId, inputs },
    mutation: upsertEmergencyScenarioAccessPointsDocument,
  });
}
